import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/achieve.png'


const _withScopeId = n => (_pushScopeId("data-v-3c70d3b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content content-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-3c70d3b6><p class=\"title\" data-v-3c70d3b6><span class=\"highlight\" data-v-3c70d3b6>We achieve</span> the best results for your company <br data-v-3c70d3b6> by focusing on data analytics and flexibility </p><p class=\"subTitle\" data-v-3c70d3b6> We constantly monitor the results and amend the strategy <br data-v-3c70d3b6> accordingly to achieve the highest efficiency. </p><div class=\"line\" data-v-3c70d3b6></div><p class=\"description\" data-v-3c70d3b6> We use data to create content that <br data-v-3c70d3b6> will capture the attention of your <br data-v-3c70d3b6> target audience and drive them to <br data-v-3c70d3b6> action </p></div><img class=\"image\" src=\"" + _imports_0 + "\" alt=\"achieve\" data-v-3c70d3b6>", 2)
const _hoisted_4 = [
  _hoisted_2
]

import VueScrollTo from 'vue-scrollto'
import { inject, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Achieve',
  setup(__props) {

const scrollTo = VueScrollTo.scrollTo

const data = reactive({

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
}
}

})